module.exports = __webpack_public_path__ + "img/slide-dog3.b5d30437.png";